import Skeleton from 'react-loading-skeleton';

import { Text } from '../../cdl/Text/Text';
import { Box } from '../../common/ui/Box';

export const LoadingPriceBox = () => {
    return (
        <Box
            position="relative"
            paddingTop={16}
            paddingLeft={16}
            paddingRight={16}
            backgroundColor="white"
            width="240px"
            height="220px"
            borderRadius="4px"
            boxShadow="medium"
            borderWidth="1px"
            borderStyle="solid"
            borderColor="border.muted"
        >
            <Text size={16} weight="semi">
                <Skeleton />
            </Text>

            <Text size={24} marginTop={6}>
                <Skeleton />
            </Text>

            <Box marginTop={8}>
                <Text size={14}>
                    <Skeleton />
                </Text>
            </Box>

            <Box position="absolute" bottom={16} left={5} right={5}>
                <Skeleton />
            </Box>
        </Box>
    );
};
